<template>
  <div class="changePassword-form _flxccc">
    <div class="changePassword-view__load _flxcs">
      <h3>Change password</h3>
      <label for="password" >New password*</label>
      <input name="password" v-validate="'required'" type="password" autocomplete="current-password" @keydown.enter="save()" placeholder="Password" v-model="password" />
      <span class="invalid">{{ errors.first('password') }}</span>
      <button title="Save" class="button" @click="save()">Save</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'changePassword',
  data: () => ({
    password: '',
    token: ''
  }),
  mounted() {
    this.token = window.location.href.split('token=')[1];
  },
  methods: {
    ...mapActions(['changePassword', 'notify']),
    save: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
          const that = this
          this.changePassword({password: this.password, token: this.token}).then(() => {
            this.notify({title: 'Changed password', text: 'Your password was changed', sticky: 2000})
            that.$router.push('project')
          }, () => {
            that.$router.push('login')
          });
        }
      })
    }
  }
}
</script>
